<template>
  <transition name="fade">
    <div class="ew-loader" v-if="show">
      <img :src="loader" />
    </div>
  </transition>
</template>

<script>
import loader from "@/assets/images/ew-loader.svg";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loader,
    };
  },
};
</script>

<style lang="scss">
.ew-loader {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  img {
    width: 80%;
    min-width: 32px;
    height: 80%;
  }
}
</style>